import NotificationsDataConverter from './notificationsDataConverter';

export const notifications = {
    NotificationsDataConverter: NotificationsDataConverter
};
